<template>
  <v-simple-table class="events-on-property">
    <template #default>
      <thead>
        <tr>
          <th>Event</th>
          <th>Status</th>
          <th>Sensor</th>
          <th>Start Time</th>
          <th>End Time</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(event, id) in eventList"
          :key="id"
        >
          <td>
            <v-icon
              size="16"
              color="black"
              class="mr-4"
            >
              {{ event.eventClass | icon }}
            </v-icon>
            <span class="event-type">{{ event.eventClass | label }}</span>
          </td>
          <td>{{ event.status }}</td>
          <td>{{ event.zone }}</td>
          <td>{{ event.localStartDateTime | date }} <span style="font-weight:bold">{{ event.localStartDateTime | time }}</span> ({{ event.localStartDateTime | timezone }})</td>
          <td>
            <template v-if="event.localEndDateTime">
              {{ event.localEndDateTime | date }} <span style="font-weight:bold">{{ event.localEndDateTime | time }}</span> ({{ event.localEndDateTime | timezone }})
            </template>
            <span v-else>In Progress</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  import { DateTime } from 'luxon'
  import { getEventIcon, getEventLabel } from '@/helpers/event-helpers'
  export default {
    name: 'ListEventsOnProperty',
    filters: {
      icon (value) {
        return getEventIcon(value)
      },
      label (value) {
        return getEventLabel(value)
      },
      date (value) {
        return DateTime.fromISO(value).toFormat('dd LLL yyyy')
      },
      time (value) {
        return DateTime.fromISO(value).toFormat('h:mm a')
      },
      timezone (value) {
        return DateTime.fromISO(value).toFormat('ZZZZ')
      },
    },
    props: {
      eventList: {
        type: Array,
      },
    },
  }
</script>

<style lang="scss" scoped>
.events-on-property td {
  white-space: nowrap;
}
.event-type {
    font-weight: bold;
    color: $muted;
}
</style>
